import React from "react";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./OSBlock.styles";

function OSBlock({ type, data }) {
  const getStyles = (field) => {
    if (type === "default") {
      return styles.brick;
    }
    if (data[field]) {
      return {
        ...styles.brick,
        ...styles[`${field}Filled`],
      };
    }
    return { ...styles.brick, ...styles[field] };
  };
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item style={getStyles("area")}>
        <Typography style={styles.text}>
          {data.area ? data.area : "Area"}
        </Typography>
      </Grid>
      <Grid item style={getStyles("zone")}>
        <Typography style={styles.text}>
          {data.zone ? data.zone : "Zone"}
        </Typography>
      </Grid>
      <Grid item style={getStyles("region")}>
        <Typography style={styles.text}>
          {data.region ? data.region : "Region"}
        </Typography>
      </Grid>
      <Grid item style={getStyles("chapter")}>
        <Typography style={styles.text}>
          {data.chapter ? data.chapter : "Chapter"}
        </Typography>
      </Grid>
      <Grid item style={getStyles("district")}>
        <Typography style={styles.text}>
          {data.district ? data.district : "District"}
        </Typography>
      </Grid>
    </Grid>
  );
}

const propTypes = {
  type: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.string),
};
const defaultProps = {
  type: "deafult",
  data: {},
};

OSBlock.propTypes = propTypes;
OSBlock.defaultProps = defaultProps;

export default OSBlock;
